module.exports = __webpack_public_path__ + "img/zip.c66fcec.svg";